function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This component, given a single DOMHighlight, draws highlight rectangles in
 * the same absolute position as the highlighted content, as computed via
 * `getClientRects`.
 *
 * TODO(mdr): Many things can affect the correct positioning of highlighting,
 *     and this component does not attempt to anticipate them. If we start
 *     using this highlighting library on content with a more dynamic layout,
 *     we should add a hook to allow the parent to `forceUpdate` the
 *     `HighlightRenderer`.
 */
var React = require("react");

var _require = require("aphrodite"),
    StyleSheet = _require.StyleSheet,
    css = _require.css;

var _require2 = require("./util.js"),
    getClientRectsForTextInRange = _require2.getClientRectsForTextInRange,
    getRelativePosition = _require2.getRelativePosition,
    getRelativeRect = _require2.getRelativeRect;

var babelPluginFlowReactPropTypes_proptype_ZIndexes = require("./types.js").babelPluginFlowReactPropTypes_proptype_ZIndexes || require("react").PropTypes.any;

var babelPluginFlowReactPropTypes_proptype_Rect = require("./types.js").babelPluginFlowReactPropTypes_proptype_Rect || require("react").PropTypes.any;

var babelPluginFlowReactPropTypes_proptype_Position = require("./types.js").babelPluginFlowReactPropTypes_proptype_Position || require("react").PropTypes.any;

var babelPluginFlowReactPropTypes_proptype_DOMHighlight = require("./types.js").babelPluginFlowReactPropTypes_proptype_DOMHighlight || require("react").PropTypes.any;

var HighlightRenderer = function (_React$PureComponent) {
    _inherits(HighlightRenderer, _React$PureComponent);

    function HighlightRenderer() {
        var _temp, _this, _ret;

        _classCallCheck(this, HighlightRenderer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            cachedHighlightRects: _this._computeRects(_this.props),
            tooltipIsHovered: false
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    HighlightRenderer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.highlight !== nextProps.highlight || this.props.offsetParent !== nextProps.offsetParent) {
            this.setState({
                cachedHighlightRects: this._computeRects(nextProps)
            });
        }
    };

    /**
     * Compute the set of rectangles that cover the highlighted content, with
     * coordinates relative to the offset parent. That way, we can use them
     * for CSS positioning.
     */


    HighlightRenderer.prototype._computeRects = function _computeRects(props) {
        var highlight = props.highlight,
            offsetParent = props.offsetParent;

        // Get the set of rectangles that covers the range's text, relative to
        // the offset parent.

        var clientRects = getClientRectsForTextInRange(highlight.domRange);
        var offsetParentRect = offsetParent.getBoundingClientRect();
        var relativeRects = clientRects.map(function (rect) {
            return getRelativeRect(rect, offsetParentRect);
        });

        return relativeRects;
    };

    /**
     * Return whether the given mouse position (coordinates relative to this
     * component's offset parent) is hovering over the given rectangle
     * (coordinates also relative to this component's offset parent).
     */


    HighlightRenderer.prototype._rectIsHovered = function _rectIsHovered(rect, mouseOffsetPosition) {
        var positionWithinRect = getRelativePosition(mouseOffsetPosition, rect);

        return 0 <= positionWithinRect.left && positionWithinRect.left < rect.width && 0 <= positionWithinRect.top && positionWithinRect.top < rect.height;
    };

    /**
     * Return whether the given mouse position (coordinates relative to the
     * viewport) is hovering over this highlight.
     */


    HighlightRenderer.prototype.isHovered = function isHovered(mouseClientPosition) {
        var _this2 = this;

        if (!mouseClientPosition) {
            return false;
        }

        var offsetParent = this.props.offsetParent;
        var cachedHighlightRects = this.state.cachedHighlightRects;

        // Convert the client-relative mouse coordinates to be relative to the
        // offset parent. That way, we can compare them to the cached highlight
        // rectangles.

        var offsetParentRect = offsetParent.getBoundingClientRect();
        var mouseOffsetPosition = getRelativePosition(mouseClientPosition, offsetParentRect);

        return cachedHighlightRects.some(function (rect) {
            return _this2._rectIsHovered(rect, mouseOffsetPosition);
        });
    };

    HighlightRenderer.prototype.render = function render() {
        var _this3 = this;

        var rects = this.state.cachedHighlightRects;

        return React.createElement(
            "div",
            null,
            rects.map(function (rect, index) {
                return React.createElement("div", {
                    key: index,
                    className: css(styles.highlightRect),
                    style: {
                        // NOTE(mdr): We apply `position: absolute` here
                        //     rather than in Aphrodite styles, because
                        //     Aphrodite styles are delayed. If this
                        //     element temporarily has `position: static`,
                        //     then it'll displace the content, and other
                        //     highlights rendering during this update will
                        //     measure the displaced content instead, oops!
                        position: "absolute",
                        width: rect.width,
                        height: rect.height,
                        top: rect.top,
                        left: rect.left,
                        zIndex: _this3.props.zIndexes.belowContent
                    }
                });
            })
        );
    };

    return HighlightRenderer;
}(React.PureComponent);

HighlightRenderer.propTypes = {
    highlight: babelPluginFlowReactPropTypes_proptype_DOMHighlight,
    highlightKey: require("react").PropTypes.string.isRequired,
    offsetParent: require("react").PropTypes.any.isRequired,
    zIndexes: babelPluginFlowReactPropTypes_proptype_ZIndexes
};


var styles = StyleSheet.create({
    highlightRect: {
        background: "#fffabe" // highlighter yellow :)
    }
});

module.exports = HighlightRenderer;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/highlighting/ui/highlight-renderer.jsx
 ** module id = 402
 ** module chunks = 0 1
 **/